import { enableBodyScroll } from '../../../utilities/behavior-helpers/index.js';
import '../../../utilities/dom-helpers/index.js';

const playYtVimeoVideo = (videoIframe) => {
    const src = videoIframe.getAttribute('src');
    const d = (src === null || src === void 0 ? void 0 : src.includes('?')) ? '&' : '?';
    if (src === null || src === void 0 ? void 0 : src.includes('autoplay'))
        return;
    videoIframe === null || videoIframe === void 0 ? void 0 : videoIframe.setAttribute('src', `${src}${d}autoplay=1&playsinline=1`);
};
const close = (ctx) => {
    var _a, _b;
    enableBodyScroll();
    ctx.removeAttribute('show');
    // return focus back to the popup trigger button
    const triggerButton = document.querySelector(`[data-target="${ctx.id}"]`);
    if (triggerButton) {
        (_a = triggerButton.querySelector('button')) === null || _a === void 0 ? void 0 : _a.focus();
        return;
    }
    const triggerButtonVideoBlock = (_b = ctx.parentElement) === null || _b === void 0 ? void 0 : _b.querySelector(`[data-target="${ctx.id}"]`);
    if (triggerButtonVideoBlock)
        triggerButtonVideoBlock.focus();
};
const handleClickOutside = (e, ctx) => {
    if (!e
        .composedPath()
        .includes(document.querySelector('.lightboxes-container .inner'))) {
        close(ctx);
    }
};

export { close, handleClickOutside, playYtVimeoVideo };
